import React from "react";
import { MapPin, Navigation, Car, TrainFront } from "lucide-react";
import { useLang, CONTACT } from "../../translations";
import { FadeUp } from "./Reveal";

const accessIcons = [TrainFront, Car, Navigation];

export const Location = () => {
  const { t } = useLang();
  const mapSrc = `https://www.google.com/maps?q=${CONTACT.mapsQuery}&output=embed`;
  const mapLink = `https://www.google.com/maps/dir/?api=1&destination=${CONTACT.mapsQuery}`;

  return (
    <section id="location" data-testid="location-section" className="py-24 md:py-36 bg-cream">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-12 grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
        <FadeUp>
          <p className="text-xs uppercase tracking-[0.28em] text-sage mb-4">{t.location.label}</p>
          <h2 className="font-heading text-4xl md:text-5xl lg:text-[3.4rem] text-ink leading-[1.05] tracking-tight">
            {t.location.title}
          </h2>

          <div className="mt-8 flex items-start gap-3">
            <MapPin className="text-sage mt-1 shrink-0" size={20} />
            <div>
              <p className="text-xs uppercase tracking-[0.2em] text-muted2">{t.location.addressLabel}</p>
              <p className="text-lg text-ink mt-1">{CONTACT.address}</p>
            </div>
          </div>

          <h3 className="font-heading text-2xl text-ink mt-10 mb-4">{t.location.access}</h3>
          <ul className="space-y-4">
            {t.location.accessItems.map((a, i) => {
              const Icon = accessIcons[i] || Navigation;
              return (
                <li key={i} data-testid={`access-item-${i}`} className="flex items-start gap-3 text-muted2">
                  <span className="h-9 w-9 rounded-full bg-sage/12 flex items-center justify-center text-sage shrink-0">
                    <Icon size={17} />
                  </span>
                  <span className="leading-relaxed pt-1">{a}</span>
                </li>
              );
            })}
          </ul>

          <a
            data-testid="directions-link"
            href={mapLink}
            target="_blank"
            rel="noopener noreferrer"
            className="mt-8 inline-flex items-center gap-2 rounded-full bg-ink text-cream px-7 py-3.5 hover:bg-sage transition-colors duration-300"
          >
            <Navigation size={16} /> {t.location.directions}
          </a>
        </FadeUp>

        <FadeUp delay={0.15}>
          <div className="rounded-[1.5rem] overflow-hidden border border-ink/10 shadow-xl aspect-square lg:aspect-[4/5]">
            <iframe
              data-testid="location-map"
              title="Cabinet La Tour-de-Peilz"
              src={mapSrc}
              className="h-full w-full"
              style={{ border: 0 }}
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        </FadeUp>
      </div>
    </section>
  );
};
